<template>
  <div>
    <v-expansion-panels class="px-4" flat>
      <v-expansion-panel
        v-for="(item, index) in customComponents"
        :key="index"
        :disabled="loading"
        class="mb-4"
      >
        <v-expansion-panel-header class="text-right">
          <div class="d-flex justify-space-between align-center">
            <div>
              <v-icon class="me-2">mdi-{{ item.icon }}</v-icon>
              {{ item.title }}
            </div>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="py-5">
          <component
            :is="item.name"
            :key="item.model"
            v-model="value[item.model]"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import DesignSamples from "./cm/designSamples.vue";
import MarkerRadius from "./cm/markerRadius.vue"; //
import MarkerCenter from "./cm/markerCenter.vue"; //
import QrFrame from "./cm/qrFrame.vue"; //
import QrColors from "./cm/qrColors.vue"; //
import QrMarkOut from "./cm/qrMarkOut.vue"; //
import LogoImg from "./cm/logoImg.vue"; //

export default {
  name: "qrCustomize",

  components: {
    LogoImg,
    QrMarkOut,
    QrColors,
    QrFrame,
    MarkerCenter,
    MarkerRadius,
    DesignSamples,
  },

  props: {
    value: {
      type: Object,
    },
    loading: false,
    serviceName: { type: String, default: "Qrland" },
    componentName: { type: String, default: "" },
  },

  data() {
    return {
      helpData: [],
      customComponents: [
        {
          name: "DesignSamples",
          value: "",
          title: "طرح و سایز کیوآر",
          subtitle: "",
          icon: "qrcode-edit",
          model: "qrStyleColors",
        },
        {
          name: "MarkerCenter",
          value: "",
          title: "طرح چشم کیوآر",
          subtitle: "",
          icon: "qrcode-edit",
          model: "MarkerCenter",
        },
        {
          name: "QrMarkOut",
          value: "",
          title: "حاشیه خروجی",
          subtitle: "",
          icon: "qrcode-edit",
          model: "QrMarkOut",
        },
        {
          name: "QrFrame",
          value: "",
          title: "فریم",
          subtitle: "",
          icon: "qrcode-edit",
          model: "QrFrame",
        },
        {
          name: "LogoImg",
          value: "",
          title: "لوگو",
          subtitle: "",
          icon: "qrcode-edit",
          model: "LogoImg",
        },
      ],
      qrDesign: {},
    };
  },
  watch: {
    qrDesign: {
      handler(value) {
        this.$emit("input", value);
      },
      deep: true,
    },
  },
  mounted() {
    if (this.$route.name !== "qr.id.design")
      this.qrDesign = {
        qrStyleColors: {
          backcolor: "",
          frontColor: "",
          gradient_color: "",
          gradient: false,
          pattern: "default",
        },
        MarkerCenter: {
          topRight: "",
          bottomLeft: "",
          main: "",
          different_markers_color: false,
          eyePattern: "default",
        },
        QrMarkOut: {
          topRight: "",
          bottomLeft: "",
          markOutPattern: "default",
          main: "",
          different_markers_color: false,
        },
        QrFrame: {
          main: "",
          text: "SCAN ME",
          framePattern: "none",
          different_markers_color: false,
        },
        LogoImg: { noBg: false, logoSize: 100, logoImg: "none" },
      };
  },
};
</script>

<style scoped>
.v-expansion-panel {
  border-radius: 15px !important;
  box-shadow: 8px 5px 10px #f49d1a;
}

.v-expansion-panel
  >>> .v-expansion-panel-header.v-expansion-panel-header--active {
  background-color: #001554 !important;
  border-radius: 15px !important;
  color: whitesmoke !important;
}

.v-expansion-panel
  >>> .v-expansion-panel-header.v-expansion-panel-header--active
  .v-icon {
  color: whitesmoke !important;
}
</style>
